import React from "react"
import {Link} from "gatsby"
import * as styles from "./socialLinksNav.module.css"

interface SocialLinksNavProps {
	contextClassName?: String
}

export default function socialLinksNav({
	contextClassName,
}: SocialLinksNavProps) {
	return (
		<ul className={`${styles.socialLinksNav} ${contextClassName}`}>
			<li>
				<a
					href="https://www.youtube.com/@nate-weiner"
					className={`${styles.youtube} ${styles.icon}`}
					target="_blank"
				>
					YouTube
				</a>
			</li>
			<li>
				<a
					className={`${styles.instagram} ${styles.icon}`}
					href="https://www.instagram.com/nateweiner/"
					target="_blank"
				>
					Instagram
				</a>
			</li>
			<li>
				<a
					href="https://www.threads.net/@nateweiner"
					className={`${styles.threads} ${styles.icon}`}
					target="_blank"
				>
					Threads
				</a>
			</li>
			<li>
				<a
					className={`${styles.linkedin} ${styles.icon}`}
					href="https://www.linkedin.com/in/nateweiner/"
					target="_blank"
				>
					LinkedIn
				</a>
			</li>
			<li>
				<Link
					className={`${styles.twitter} ${styles.icon}`}
					to="https://twitter.com/nateweiner"
					target="_blank"
				>
					X/Twitter
				</Link>
			</li>
		</ul>
	)
}
